import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon, Input, Spinner } from '@/components/atoms';
import { QUESTION_POPUP_TEST_IDS } from '@/constants/data-testids';
import { TranslationQuestion } from '@/types/management/managementCategories';

type EditTranslationQuestionProps = {
  newCompanyName: string;
  editingOption: TranslationQuestion | null;
  isLoadingSaveChanges?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onEditChange: (newValue: string) => void;
};

export const EditTranslationQuestion: FC<EditTranslationQuestionProps> = ({
  newCompanyName,
  editingOption,
  isLoadingSaveChanges,
  onEditChange,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation('components');
  if (!editingOption) return null;
  return (
    <div data-testid={QUESTION_POPUP_TEST_IDS.STEP2_EDIT}>
      <p className="text-body-20-semibold text-custom-warm-grey-800 mb-2">
        {t('editTranslationQuestion.title')}
      </p>
      <div className="flex items-center gap-2 mb-5">
        <Icon name={editingOption.languageCode} width={16} height={16} />
        <p className="grow">{editingOption.text}</p>
      </div>
      <div>
        <Input
          value={newCompanyName}
          onChange={e => onEditChange(e.target.value)}
          placeholder={t('editTranslationQuestion.inputPlaceholder')}
          hintText={t('editTranslationQuestion.hintText')}
          className="w-full"
        />
      </div>
      <div className="flex items-center gap-3">
        <Button size="lg" variant="secondary" className="w-full" onClick={onCancel}>
          {t('editTranslationQuestion.cancelButton')}
        </Button>
        <Button size="lg" variant="primary" className="relative w-full" onClick={onSave}>
          {t('editTranslationQuestion.saveButton')}{' '}
          {isLoadingSaveChanges && (
            <Spinner className="absolute top-1/2 -translate-y-1/2 right-8" />
          )}
        </Button>
      </div>
    </div>
  );
};
